const route = {
    path: '/generator',
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "generator" */ '../../components/views/generator/generator.vue'),
            }
        },
    ],
}

module.exports = route;